import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { api, getToken, setToken } from "@/lib/api";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import CompanyProfile from "@/pages/CompanyProfile";
import Buyers from "@/pages/Buyers";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Bids from "@/pages/Bids";
import BidWorkspace from "@/pages/BidWorkspace";
import Certificates from "@/pages/Certificates";
import DocumentBuilder from "@/pages/DocumentBuilder";
import BidTracker from "@/pages/BidTracker";
import BidIntel from "@/pages/BidIntel";
import { Loader2 } from "lucide-react";

function App() {
  const [authed, setAuthed] = useState(null); // null = checking, true, false

  useEffect(() => {
    if (!getToken()) { setAuthed(false); return; }
    api.get("/auth/me").then(() => setAuthed(true)).catch(() => { setToken(null); setAuthed(false); });
  }, []);

  if (authed === null) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <Loader2 className="h-6 w-6 text-emerald-400 animate-spin" />
      </div>
    );
  }

  if (!authed) {
    return (
      <div className="App">
        <Login onLogin={() => setAuthed(true)} />
        <Toaster position="top-right" richColors />
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/" element={<Overview />} />
            <Route path="/company" element={<CompanyProfile />} />
            <Route path="/buyers" element={<Buyers />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:productId" element={<ProductDetail />} />
            <Route path="/certificates" element={<Certificates />} />
            <Route path="/bids" element={<Bids />} />
            <Route path="/bids/:bidId" element={<BidWorkspace />} />
            <Route path="/builder" element={<DocumentBuilder />} />
            <Route path="/tracker" element={<BidTracker />} />
            <Route path="/tracker/:bidId/intel" element={<BidIntel />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
